import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import accessibility from "highcharts/modules/accessibility";
import HighchartsReact from "highcharts-react-official";
accessibility(Highcharts);
export default function DynamicPieChart(props) {
  const [chartWidth, setChartWidth] = useState(200);

  const handleResize = () => {
    const width =
      document.getElementById("chart-container")?.clientWidth || 200;
    setChartWidth(width);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // Format data for Highcharts
  const seriesData = props?.data?.map((item) => ({
    name: item.label,
    y: item.value,
  }));

  // Highcharts configuration options
  const options = {
    chart: {
      type: "pie",
      width: chartWidth,
      height: 280, 
      accessibility: {
        enabled: true, // Enable accessibility features
      },
    },
    title: {
      text: props.label,
    },
    plotOptions: {
      pie: {
        innerSize: "50%", // Set the inner size to create a donut chart
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
      },
    },
    tooltip: {
      pointFormat: `<b>${props.dataLabel}:</b> {point.y}`,
    },
    series: [
      {
        data: seriesData,
        label: props.dataLabel,
      },
    ],
  };

  return (
    <div className="container-fluid d-flex align-items-center justify-content-center">
      <div className="card shadow-sm p-1">
        <div className="card-body">
          {props?.data?.length > 0 ? (
            <div
              id="chart-container"
              style={{ width: "100%"}}
            >
              <HighchartsReact highcharts={Highcharts} options={options} />
              <p className="fs-5 fw-bold orange-text">{props?.Total}</p>
            </div>
          ) : (
            <p className="text-center py-3">No Data available</p>
          )}
        </div>
      </div>
    </div>
  );
}
